import React from "react"
import InfiniteSelectDropdown, { SelectOption } from "./InfiniteSelectDropdown"
import { getEnrollments, Enrollment } from "../../service/enrollment"

export interface EnrollmentFilters {
  sortBy?: string
  sortOrder?: string
  system?: string
  branch?: string
  session?: string
  class?: string
  section?: string
  gender?: string
  status?: string
  statusScope?: "fees" | "onroll"
}

interface StudentDropdownProps {
  // value?: SelectOption[] | SelectOption
  // onChange: (selectedStudents: SelectOption[] | SelectOption) => void
  value?: any
  onChange: (selectedStudents: any) => void
  placeholder?: string
  isMulti?: boolean
  className?: string
  isDisabled?: boolean
  limit?: number
  // Additional filters for enrollments
  filters?: EnrollmentFilters
}

const StudentDropdown: React.FC<StudentDropdownProps> = ({
  value = [],
  onChange,
  placeholder = "Select students",
  isMulti = true,
  className,
  isDisabled = false,
  limit = 10,
  filters = {},
}) => {
  const fetchEnrollmentData = async ({
    page,
    limit: pageLimit,
    searchText,
  }: {
    page: number
    limit: number
    searchText?: string
  }) => {
    const response = await getEnrollments({
      page,
      limit: pageLimit,
      searchText,
      status: "active", // Default to active enrollments only
      // Every place this dropdown is used (issuing a library book, assigning
      // transport, ...) is picking a currently-enrolled student — a caller
      // that genuinely needs a different set can still override via filters.
      statusScope: "onroll",
      ...filters, // Include additional filters like class, branch, session, etc.
    })

    return {
      data: response.data,
      pagination: {
        currentPage: response.pagination.page,
        hasNextPage: response.pagination.hasNextPage || false,
        hasPrevPage: response.pagination.hasPrevPage || false,
        limit: response.pagination.limit,
        total: response.pagination.total,
        totalPages: response.pagination.totalPages,
      },
    }
  }

  const formatEnrollmentOption = (enrollment: Enrollment): SelectOption => {
    const user = enrollment.user
    const student = enrollment.student
    const fullName = `${user?.firstName || ""} ${user?.lastName || ""}`.trim()
    const grNumber = student?.grNumber ? ` (${student.grNumber})` : ""
    const className = enrollment.class?.name
      ? ` - ${enrollment.class.name}`
      : ""
    const sectionName = enrollment.section?.name
      ? `-${enrollment.section.name}`
      : ""

    return {
      value: user._id, // Using user ID as value (matches library modal expectation)
      label: `${fullName}${grNumber}${className}${sectionName}`,
    }
  }

  return (
    <InfiniteSelectDropdown<Enrollment>
      fetchData={fetchEnrollmentData}
      formatOption={formatEnrollmentOption}
      value={value}
      onChange={onChange}
      placeholder={placeholder}
      isMulti={isMulti}
      className={className}
      isDisabled={isDisabled}
      limit={limit}
    />
  )
}

export default StudentDropdown